// Copyright (c) 2016 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getDealerTransferHistoryColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'currentDealer',
            field: 'currentDealer',
            headerClass: classNames.headerClassName,
            headerName: translate('CURRENT_ACCOUNT'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'currentDealerName',
            field: 'currentDealerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CURRENT_DEALER'),
            width: 200

        },
        {
            cellClass: classNames.cellClassName,
            colId: 'newDealer',
            field: 'newDealer',
            headerClass: classNames.headerClassName,
            headerName: translate('NEW_ACCOUNT'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'newDealerName',
            field: 'newDealerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('NEW_DEALER'),
            width: 200

        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'requestDate',
            field: 'requestDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('REQUESTED'),
            width: 120
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'requestedBy',
            field: 'requestedBy',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('REQUESTED_BY'),
            width: 200

        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'changedOn',
            field: 'changedOn',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('CHANGED_ON'),
            width: 130

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'changedBy',
            field: 'changedBy',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CHANGED_BY'),
            width: 200

        },
        {
            cellClass: classNames.cellClassName,
            colId: 'statusIndicator',
            field: 'statusIndicator',
            headerClass: classNames.headerClassName,
            headerName: translate('STATUS_INDICATOR'),
            width: 160
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'customer',
            field: 'customer',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CUSTOMER'),
            width: 200

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'reasonForChange',
            field: 'reasonForChange',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('REASON_FOR_CHANGE'),
            width: 250
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'deereRemarks',
            field: 'deereRemarks',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEERE_REMARKS'),
            width: 250

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'approvalDealerComments',
            field: 'approvalDealerComments',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('APPROVAL_DEALER_COMMENTS'),
            width: 250

        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/report-services/column-definitions.js